import styled from 'styled-components';
import { StyledAddMemberPopup } from 'pages/CommunityOverallScheduler/CreateEventGroupPopup/styled';

export const SubscriptionPopupCard = styled(
  StyledAddMemberPopup.CardWrapper.Card,
)`
  ${StyledAddMemberPopup.CardWrapper.Card.Header} {
    align-items: flex-start;
    align-self: center;
    max-width: 480px;
    width: 100%;
  }

  ${StyledAddMemberPopup.CardWrapper.Card.title} {
    text-align: left;
  }

  ${StyledAddMemberPopup.CardWrapper.Card.subTitle} {
    text-align: left;
  }
`;
